<template>
  <div>
    <ul>
      <li class="item" v-for="(item, index) in list" :key="index">
        <i class="iconfont font" :class="item.icon"></i>
        <span class="text"> {{ item.time }}{{ item.text }}</span>
        <span class="operate" @click="handleClick(item.time)">{{ item.operate }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { geturl } from '@/utils/index';
export default {
  name: 'Home',
  data() {
    return {
      list: [
      ]
    };
  },

  methods: {
    // 获取近7天的日期 以数组形式返回 时间格式为 yyyy年mm月dd日
    getDateList() {
      const dateList = [];
      const today = new Date();
      for (let i = 0; i < 7; i++) {
        const date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const dateStr = `${year}年${month}月${day}日`;
        dateList.push(dateStr);
      }
      return dateList;
    },
    handleClick(item) {
      // 跳转到详情页topic 并传递参数
      this.$router.push({
        path: '/topic',
        query: {
          time: item
        }
      });
    }
  },
  mounted() {
    // 获取浏览器url中的id参数
    let params = geturl()
    // const id = 'oEqTa6UrfBsR5xtBIgQv1MRaHikI'
    // 如果有id参数，则存到浏览器中
    if (params && params.openId) {
      const id = params.openId
      localStorage.setItem('id', id);
    }
    // 获取近7天的日期
    const dateList = this.getDateList();
    // 循环设置数据
    this.list = [];
    for (let i = 0; i < dateList.length; i++) {
      this.list.push({
        icon: 'icon-shijian1',
        time: dateList[i],
        text: '预警日报',
        operate: '查看 >'
      });
    }
  },
}
</script>
<style lang="less" scoped>
.popup-shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, .5);
  z-index: 20;
}

.item {
  padding: 10px;
  border-bottom: 1px solid #000;

  .font {
    font-size: 20px;
    color: #ed9920;
    font-weight: 600;
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
  }

  .operate {
    float: right;
    color: #007aff;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
    margin-top: 5px;
  }


}


// .slide-enter, .slide-leave-to {
//   // 过渡之前的样式写在这里
//    right: -100%;
// }
// .slide-enter-active,.slide-leave-active  {
//   // 过渡属性写在这里
//   transition: all .3s;
// }
// .slide-enter-to, .slide-leave {
//   // 过渡之后的样式写在这里
//    right: 0;
// }
</style>
